import { GA_DEFAULT_PAYLOAD } from 'Tracking/constants.js';

export const BE_CATEGORY_GA = 'bookingEngine';
export const BE_SAVE_VALIDATE_GA = 'validate';
export const BE_SAVE_CLICK_GA = 'click';
export const BE_SIGNIN_CLICK_GA = 'login';
export const BE_SIGNUP_CLICK_GA = 'createAccount';
export const BE_FACEBOOK_CONNECT_CLICK_GA = 'facebookconnect';
export const BE_SHARE_ACTION = 'share-action';
export const BE_SAVE_ACTION = 'save-action';

export const BE_SAVE_CRITERIA_QUERY = 'openSaveConfirmationModal';
export const BE_SAVE_CRITERIA_NEW_ACCOUNT_QUERY = 'newAccount';

export const BOOKING_QUERY_PARAMS = 'bookingQueryParams';

export const BE_GA_DEFAULT_PAYLOAD = {
  ...GA_DEFAULT_PAYLOAD,
  categoryGA: BE_CATEGORY_GA,
};

export const CXO_STEP = {
  CONFIGURE: 'configure',
  AFFICHAGE: 'affichage',
  PAYMENT: 'payment',
};

export const CXO_STEP_GA = {
  configure: 'CXO_modifyFile',
  affichage: 'CXO_saveOption',
  payment: 'CXO_confirm',
};

export const PAGES = {
  ACTIVITIES: 'activities',
  BANKING: 'banking',
  ACCOMMODATION: 'accommodation',
  TRANSPORT: 'transport',
  SERVICES: 'services',
  PARTICIPANTS: 'participants',
  SUMMARY: 'summary',
};

export const MULTI_SCHEDULE_RESORTS = ['TOMC_WINTER', 'SAOC_WINTER'];
